export const SUPPORT_USER_ID = 107;
export const ADMIN_USER_ID = 1;

export const INTERNAL_EMAIL_DOMAIN = '@myre.fr';

export const GOD_USER_IDS = [SUPPORT_USER_ID] as const;

export const ADMIN_USER_IDS = [...GOD_USER_IDS, ADMIN_USER_ID] as const;

export const CSM_USER_IDS = [
  ...ADMIN_USER_IDS,
  293,
  549,
  580,
  730,
  796,
] as const;
